import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { callApi, formatDate, formatMoney, formatMoneyShorten, getCurrentDateForInput } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import OneClassroom from '../ones/OneClassroom';
import { MdCheck, MdSms, MdWhatsapp } from "react-icons/md";

export default function DiscountRegistrationForm({ studentUuid, callback, data }) {

  const appContext = useContext(AppContext);

  /* Place states here */
  const [ready, setReady] = useState(false);
  const [loading, setLoading] = useState(false);

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [amount, setAmount] = useState(0);

  const [discountCycleType, setDiscountCycleType] = useState('');
  const [discountIndividualCycleUuid, setDiscountIndividualCycleUuid] = useState('');
  const [discountGeneralCycleUuid, setDiscountGeneralCycleUuid] = useState('');
  const [discountDebtUuid, setDiscountDebtUuid] = useState('');
  const [paymentsProfile, setPaymentsProfile] = useState(null);
  
  async function init() {
    //run initializations here
    setReady(false);
    await Promise.all([
      getPaymentsProfile(),
    ])
    setReady(true);
  }

  function resetForm() {
    setTitle("");
    setDescription('');
    setDiscountCycleType('');
    setAmount(0);
    
  }

  async function getPaymentsProfile() {
    await callApi("get-student-payments-profile", { uuid: studentUuid }).then(response => {
      if (response.status === 1) {
        setPaymentsProfile(response.data);
      } else {
        appContext.tellError("Could not fetch data, check your connection");
      }
    })
  }

  async function create() {
    if(
      discountCycleType &&
      (discountGeneralCycleUuid || discountIndividualCycleUuid || discountDebtUuid)
    ) {
      if(title && title.trim().length > 0) {
        if(!isNaN(Number(amount)) && Number(amount) > 0) {
            
          setLoading(true);
          await callApi(
            'create-discount',
            {
              title,
              description,
              studentUuid,
              amount,
              generalPaymentCycleUuid: discountGeneralCycleUuid,
              individualPaymentCycleUuid: discountIndividualCycleUuid,
              debtUuid: discountDebtUuid,
              schoolUuid: appContext.currentSchoolUuid,
            }
          ).then(response => {
            if(response.status === 1) {
              if(callback) {
                callback();
              }
              appContext.tellMessage("Successful");
              resetForm()
            } else {
              appContext.tellError(response.msg)
            }
          })
          setLoading(false);
            
          
        } else {
          appContext.tellError("Invalid amount");
        }
      } else {
        appContext.tellError("Invalid title");
      }
    } else {
      appContext.tellError("Invalid Payment cycle");
    }

    
  }

  async function edit() {
     if(
      discountCycleType &&
      (discountGeneralCycleUuid || discountIndividualCycleUuid || discountDebtUuid)
    ) {
      if(title && title.trim().length > 0) {
        if(!isNaN(Number(amount)) && Number(amount) > 0) {
            
          setLoading(true);
          await callApi(
            'edit-discount',
            {
              uuid: data.uuid,
              title,
              description,
              amount,
              generalPaymentCycleUuid: discountGeneralCycleUuid,
              individualPaymentCycleUuid: discountIndividualCycleUuid,
              debtUuid: discountDebtUuid,
            }
          ).then(response => {
            if(response.status === 1) {
              if(callback) {
                callback();
              }
              appContext.tellMessage("Successful");
              resetForm()
            } else {
              appContext.tellError(response.msg)
            }
          })
          setLoading(false);
          
        } else {
          appContext.tellError("Invalid amount");
        }
      } else {
        appContext.tellError("Invalid title");
      }
    } else {
      appContext.tellError("Invalid Payment cycle");
    }
    
  }

  useEffect(() => {
    if(data) {
      setTitle(data.title);
      setDescription(data.description);
      setAmount(data.amount);
    }
  }, [ data ])

  useEffect(() => {
    setDiscountIndividualCycleUuid('');
    setDiscountGeneralCycleUuid('');
    setDiscountDebtUuid('');
  }, [ discountCycleType ])

  useEffect(() => {
    init();
  }, [])

  

  useEffect(() => {
    appContext.setShowOverlayLoader(loading);

    return () => {
      appContext.setShowOverlayLoader(false);
    }
  }, [ loading ])

  if (ready) {
    return (
    
      <div className="row">

        <div className="col-md-12 mt-2 mb-2">
          <label className="form-label">Discount Title</label>
          <input
            className="form-control"
            value={title}
            onChange={e => setTitle(e.target.value)}
          />
        </div>


        <div className="col-md-12 mt-2 mb-2">
          <label className="form-label">Discounted Amount in TZS</label>
          <input
            className="form-control"
            value={amount}
            onChange={e => setAmount(e.target.value)}
          />
        </div>

        <div className="col-md-12 mt-2 mb-2">
          <label className="form-label">Select Payment Cycle Type</label>
          <select
            className="form-control"
            value={discountCycleType}
            onChange={(e) => {
              setDiscountCycleType(e.target.value)
            }}
          >
            <option value=""></option>
            <option value='general'>General Cycle</option>
            <option value='individual'>Individual Cycle</option>
            <option value='debt'>Debt</option>
          </select>
        </div>

        <div className="mt-3 mb-3">
          <label className="form-label">Select Payment Cycle</label>

          {
            (!discountCycleType) ?
            <select
              className="form-control"
            >
              <option value="" >Select Cycle Type First</option>
            </select>
            :""
          }

          {
            (discountCycleType === 'general') ?
            <select
              className="form-control"
              value={discountGeneralCycleUuid}
              onChange={(e) => {
                setDiscountGeneralCycleUuid(e.target.value)
              }}
            >
              <option value=''></option>
              {
                paymentsProfile.outstandingGeneralPaymentCycles?.map((item, i) => {
                  return (
                    <option key={i} value={item.uuid} >{item.title} (Balance = {formatMoney(item.balance)})</option>
                  )
                })
              }
            </select>
            :""
          }

          {
            (discountCycleType === 'individual') ?
            <select
              className="form-control"
              value={discountIndividualCycleUuid}
              onChange={(e) => {
                setDiscountIndividualCycleUuid(e.target.value)
              }}
            >
              <option value=''></option>
              {
                paymentsProfile.outstandingIndividualPaymentCycles?.map((item, i) => {
                  return (
                    <option key={i} value={item.uuid} >{item.title} (Balance = {formatMoney(item.balance)})</option>
                  )
                })
              }
            </select>
            :""
          }

          {
            (discountCycleType === 'debt') ?
            <select
              className="form-control"
              value={discountDebtUuid}
              onChange={(e) => {
                setDiscountDebtUuid(e.target.value)
              }}
            >
              <option value=''></option>
              {
                paymentsProfile.outstandingDebts?.map((item, i) => {
                  return (
                    <option key={i} value={item.uuid} >{item.title} (Balance = {formatMoney(item.balance)})</option>
                  )
                })
              }
            </select>
            :""
          }
        </div>

        

        <div className="col-md-12 mt-2 mb-2">
          <label className="form-label">Discount Description</label>
          <textarea
            className="form-control"
            value={description}
            onChange={e => setDescription(e.target.value)}
          />
          <div className="form-text">Optional</div>
        </div>

        <div className="col-md-12 mt-2 mb-2 text-end">
          <button
            className="btn btn-secondary"
            onClick={() => {
              if(data) {
                appContext.activateDialog({
                  message: `Edit this debt?`,
                  onConfirm: edit,
                })
              } else {
                appContext.activateDialog({
                  message: `Are you sure you want to issue this discount?`,
                  onConfirm: create,
                })
              }
            }}
          >
            <MdCheck/> Submit
          </button>
        </div>
      </div>
                
    )
  } else {
    return (
      <div
        className="container mSupportLoading"
      >
        {getInlineLoader()}
      </div>
    );
  }


}